import { render, staticRenderFns } from "./setupForm.vue?vue&type=template&id=6ae0be72&scoped=true&"
import script from "./setupForm.vue?vue&type=script&lang=js&"
export * from "./setupForm.vue?vue&type=script&lang=js&"
import style0 from "./setupForm.vue?vue&type=style&index=0&id=6ae0be72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae0be72",
  null
  
)

component.options.__file = "setupForm.vue"
export default component.exports